import React from "react";
import styled from "styled-components";
import { primaryColor } from "../colors";
import { mobileQuery } from "../MediaQuery";
import { MyOverflowSlider } from "../MySlider";
import { SizedBox } from "../SizedBox";
import { language, translation } from "../translations";
import { Header3, Header6, Paragraph1 } from "../typography";
import { HomeSection } from "./HomeSection";

interface TestimonialInfo {
  title: string;
  content: string;
}

interface Testimonial {
  image: string;
  infoEn: TestimonialInfo;
  infoPl: TestimonialInfo;
}

const testimonials: Array<Testimonial> = [
  {
    image: "olga.jpg",
    infoEn: {
      title: "Olga, 33 years old",
      content:
        "I use Vika every day and can see how many simple tasks I have not been doing until now. I like the healthy days' tracker when it grows I certainly feel more motivated.",
    },
    infoPl: {
      title: "Olga, 33 lata",
      content:
        "Używam Viki codziennie i widzę jak wielu prostych rzeczy nie robiłam do tej pory. Bardzo mi się podoba licznik dni zdrowia, kiedy rośnie zdecydowanie łatwiej mi się zmotywować.",
    },
  },
  {
    image: "arkadiusz.jpg",
    infoEn: {
      title: "Arek, 28 years old",
      content:
        "I treat Vika like an RPG game. By completing subsequent missions, I achieve a specific amount of experience points- in this case, days of life. Because of it, I want to fulfil and move through new quests.",
    },
    infoPl: {
      title: "Arek, 28 lat",
      content:
        "Traktuję Vikę jak grę RPG. Za przechodzenie kolejnych misji zdobywam odpowiednią liczbę punktów doświadczenia - w tym wypadku dni życia. Dzięki temu ciągle mam ochotę na zaliczanie oraz przechodzenie nowych zadań.",
    },
  },
  {
    image: "agnieszka.jpg",
    infoEn: {
      title: "Agnieszka, 34 years old",
      content:
        "An interesting and useful app, it supports me in organising new eating habits, monitoring progress and maintaining motivation on a satisfactory level. At my fingertips, I have access to expert knowledge and many interesting facts concerning healthy eating.",
    },
    infoPl: {
      title: "Agnieszka, 34 lata",
      content:
        "Ciekawa i przydatna aplikacja, wspiera mnie w porządkowaniu nowych nawyków żywieniowych, monitorowaniu postępów i utrzymaniu motywacji na dobrym poziomie. Mam dostęp do fachowej wiedzy i wielu ciekawostek na temat zdrowego żywienia w zasięgu ręki.",
    },
  },
  {
    image: "zosia.jpg",
    infoEn: {
      title: "Zosia, 40 years old",
      content:
        "Thanks to this app, I adapted a few, simple, everyday habits, such as drinking water on an empty stomach. It is made for those, who want to cooperate with their body and have control over what serves them and what doesn't.",
    },
    infoPl: {
      title: "Zosia, 40 lat",
      content:
        "Dzięki tej apce złapałam kilka prostych, dobrych, codziennych nawyków, jak picie wody na czczo. Dla tych, którzy chcą współpracować ze swoim organizmem i mieć kontrolę nad tym, co mu służy, a co niekoniecznie.",
    },
  },
  {
    image: "anna.jpg",
    infoEn: {
      title: "Anna, 37 years old",
      content:
        "A helpful motivator. A useful tool for consolidating and remembering healthy habits. Clear layout.",
    },
    infoPl: {
      title: "Anna, 37 lat",
      content:
        "Pomocny motywator. Przydatne narzędzie do utrwalenia i zapamiętania zdrowych nawyków. Przejrzysty układ.",
    },
  },
  {
    image: "malgorzata.jpg",
    infoEn: {
      title: "Małgorzata, 36 years old",
      content:
        "The application regularly reminds you to perform small tasks and strengthen good habits, such as starting the day with a glass of warmer water or eating meals regularly. The new assignments and missions motivate to take action.",
    },
    infoPl: {
      title: "Małgorzata, 36 lat",
      content:
        "Aplikacja regularnie przypomina o wykonywaniu drobnych zadań i utrwala dobre nawyki, jak chociażby zaczynanie dnia od szklanki ciepłej wody czy regularne spożywanie posiłków. Nowe zadania i misje motywują do działania.",
    },
  },
];

export const TestimonialsSection: React.FC = () => (
  <HomeSection>
    <Layout>
      <Title>{translation.joinUs}</Title>

      <SizedBox desktopHeight={32} mobileHeight={24} />

      <MyOverflowSlider>
        {testimonials.map((testimonial, i) => {
          const info =
            language === "pl" ? testimonial.infoPl : testimonial.infoEn;

          return (
            <TestimonialBox
              key={`testimonial-${i}`}
              image={testimonial.image}
              title={info.title}
              description={info.content}
            />
          );
        })}
      </MyOverflowSlider>
    </Layout>
  </HomeSection>
);

const TestimonialBox: React.FC<{
  image: string;
  title: string;
  description: string;
}> = (props) => (
  <TestimonialBoxWrapper>
    <TestimonialHeader>
      <TestimonialImage
        src={`/home/testimonials/${props.image}`}
        alt={props.title}
      />
      <SizedBox width={16} />
      <TestimonialTitle color={primaryColor}>{props.title}</TestimonialTitle>
    </TestimonialHeader>
    <SizedBox height={16} />
    <Paragraph1>{props.description}</Paragraph1>
  </TestimonialBoxWrapper>
);

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled(Header3)`
  color: ${primaryColor};
  ${mobileQuery`
    text-align: center;
  `}
`;

const TestimonialBoxWrapper = styled.div`
  display: inline-block;
  width: 380px;
  ${mobileQuery`
    width: 250px;
  `}
`;

const TestimonialHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TestimonialImage = styled.img`
  width: 50px;
  height: 50px;
`;

const TestimonialTitle = styled(Header6)`
  text-transform: uppercase;
`;
